import versionFile from "../../VERSION?raw";

/** Версията на приложението — от `VERSION` в корена на репото (същият файл
 *  тригерва Docker билда). Показва се на Login, „Модули“ и ПИН екрана. */
export const APP_VERSION = versionFile.trim();
